import React from "react";
import { Card } from "../atoms";
import Tabs from "./Tabs/Tabs";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.lg};
  padding-bottom: ${theme.spacing.md};
  border-bottom: 1px solid ${theme.colors.border};
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;

const Title = styled.h2`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.sectionHeading.fontSize};
  font-weight: ${theme.typography.sectionHeading.fontWeight};
  line-height: ${theme.typography.sectionHeading.lineHeight};
  color: ${theme.colors.primary};
  margin: 0;
`;

/**
 * Molecule: SectionCardWithTabs – card with title (optional icon), segmented tabs, content.
 */
export default function SectionCardWithTabs({
  title,
  icon,
  tabs = [],
  activeTab,
  onTabChange,
  children,
}) {
  return (
    <Card>
      <Header>
        <TitleRow>
          {icon && <span>{icon}</span>}
          <Title>{title}</Title>
        </TitleRow>
        {tabs.length > 0 && (
          <Tabs
            options={tabs}
            value={activeTab}
            onChange={onTabChange}
            variant="segments"
            tabsOnly
          />
        )}
      </Header>
      {children}
    </Card>
  );
}
